import ajax from '../utils/ajax'

export default {
    search: (from, to) => ajax.post('/api/dock/search', {from, to}),
};
